import { Messages } from '../../codegen/Localize';
import { Module } from '../Module';
import { ServerService } from './ServerService';

export class BrowserTitleService {

  public static $inject = [
    '$translate',
    'ServerService'
  ];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ServerService: ServerService
  ) { }

  /**
   * Sets the tab title to just the server name
   */
  public setTitleToServerName() {
    document.title = this.ServerService.serverName();
  }

  /**
   * Sets the tab title to a translated static place name followed by the server name. EX: 'settings', 'users', etc
   */
  public setTitleWithPlace(params: {translatablePlaceName: string}) {
    const translatedPlaceName = this.$translate.instant(params.translatablePlaceName);
    this.setTitleWithTranslatedSpace({translatedSpaceName: translatedPlaceName});
  }

  /**
   * Sets the tab title to a place name returned from a function followed by the server name. EX: 'settings', 'users', etc
   * Recommended use, pass in a string function from Messages
   * Ex: BrowserTitleService.setTitleWithPlaceNameFunction({placeNameMessagesFunction: Messages.Catalog})
   */
  public setTitleWithPlaceNameFunction(params: {placeNameFunction: () => string}) {
    this.setTitleWithTranslatedSpace({translatedSpaceName: params.placeNameFunction()});
  }

  /**
   * Sets the tab title to an already translated static space name followed by the server name. EX: 'settings', 'users', etc
   */
  private setTitleWithTranslatedSpace(params: {translatedSpaceName: string}) {
    const serverName = this.ServerService.serverName();
    document.title = Messages.browserTitle_place({ PLACE: params.translatedSpaceName, SERVER_NAME: serverName });
  }

  /**
   * Sets the tab title to be a non-translated place name followed by the server name. EX: <Project Name> - <Server Name>
   */
  public setTitleWithPlaceEntityName(params: {placeEntityName: string}) {
    const serverName = this.ServerService.serverName();
    document.title = Messages.browserTitle_place({ PLACE: params.placeEntityName, SERVER_NAME: serverName });
  }

  /**
   * Set the tab title to be a non-translated place name followed by the translatable subplace name, 
   * followed by the server name. EX: <Project Name> : 'workbooks' - <Server Name>
   */
  public setTitleWithPlaceEntityNameAndSubplaceName(params: {placeEntityName: string, translatableSubplaceName: string}) {
    const translatedSubplaceName = this.$translate.instant(params.translatableSubplaceName);
    this.setTitleWithSpaceEntityNameAndTranslatedSubspaceName({spaceEntityName: params.placeEntityName, translatedSubspaceName: translatedSubplaceName});
  }

  /**
   * Set the tab title to be a non-translated space name followed by the already translated subspace name, 
   * followed by the server name. EX: <Project Name> : 'workbooks' - <Server Name>
   */
  public setTitleWithSpaceEntityNameAndTranslatedSubspaceName(params: {spaceEntityName: string, translatedSubspaceName: string}) {
    if (params.spaceEntityName) {
      const serverName = this.ServerService.serverName();
      document.title = Messages.browserTitle_objectPlace({ OBJECT: params.spaceEntityName, PLACE: params.translatedSubspaceName, SERVER_NAME: serverName });
    } else {
      this.setTitleWithTranslatedSpace({translatedSpaceName: params.translatedSubspaceName});
    }
  }

  public setVizTitle(viewName: string, workbookName: string) {
    const serverName = this.ServerService.serverName();
    document.title = Messages.browserTitle_viz({ VIEW: viewName, WORKBOOK: workbookName, SERVER_NAME: serverName });
  }

}

Module.instance().service('BrowserTitleService', BrowserTitleService);
